
import type { SVGProps } from 'react';
const SvgWatchlistActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#watchlist-active_svg__a)">
      <path
        fill="#263E6A"
        d="M20.762 22.933A6.74 6.74 0 0 1 17.122 24a6.86 6.86 0 0 1-5.859-3.313 7 7 0 0 1-.624-1.305L4.984 22.42a.6.6 0 0 1-.27.071.48.48 0 0 1-.29-.095.54.54 0 0 1-.195-.536l1.253-7.46-.004-.011L.174 9.105a.54.54 0 0 1-.15-.551.52.52 0 0 1 .438-.355l7.33-1.088.01-.007L11.08.316c.096-.198.27-.316.466-.316s.37.118.466.316l3.278 6.788.01.007 7.33 1.088a.52.52 0 0 1 .438.355.54.54 0 0 1-.15.551l-.617.614a.41.41 0 0 1-.59-.008.433.433 0 0 1 .008-.602l.161-.16-6.718-.998a.86.86 0 0 1-.612-.454l-3.004-6.22-3.004 6.22a.86.86 0 0 1-.613.454l-6.717.998 4.86 4.842a.89.89 0 0 1 .234.736L5.16 21.363l5.238-2.814c-.644-2.851.502-5.934 3.064-7.568a6.8 6.8 0 0 1 5.483-.816.43.43 0 0 1 .291.524.416.416 0 0 1-.512.298 5.97 5.97 0 0 0-4.82.716c-2.835 1.808-3.702 5.636-1.933 8.533 1.77 2.897 5.515 3.782 8.35 1.975 2.525-1.611 3.538-4.926 2.355-7.711a.43.43 0 0 1 .217-.56.414.414 0 0 1 .548.22c1.345 3.17.194 6.941-2.678 8.773m1.113-12.047a.41.41 0 0 0-.567.166l-4.242 7.819-2.39-3.38a.41.41 0 0 0-.581-.096.43.43 0 0 0-.094.594l2.773 3.924a.41.41 0 0 0 .363.176.42.42 0 0 0 .34-.218l4.56-8.406a.43.43 0 0 0-.162-.579"
      />
    </g>
    <defs>
      <clipPath id="watchlist-active_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWatchlistActive;
